import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=8bd7ed1e&scoped=true&"
import script from "./twitter.vue?vue&type=script&lang=js&"
export * from "./twitter.vue?vue&type=script&lang=js&"
import style0 from "./twitter.vue?vue&type=style&index=0&id=8bd7ed1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7ed1e",
  null
  
)

export default component.exports